import { supportEmail } from '../../constants/utils';

interface GetSomethingGoesWrongProps {
  reason: string;
  userPossibleAction: string;
  contactSupport: boolean;
}

export const getSomethingGoesWrongMessage = ({
  reason,
  userPossibleAction,
  contactSupport
}: GetSomethingGoesWrongProps): string => {
  const reasonMessage = `Oops! Something went wrong ${reason}.`;
  const userPossibleActionMessage = `Don't worry, you can try ${userPossibleAction}.`;
  const supportMessage = contactSupport
    ? // eslint-disable-next-line max-len
      `If that doesn't work, please reach out to our friendly support team at ${supportEmail} and we'll be happy to assist you!`
    : '';

  return `${reasonMessage} ${userPossibleActionMessage} ${supportMessage}`;
};
